import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OneWebComponentsAngularModule } from '@one/angular';

@Component({
  selector: 'dl-view-notes',
  standalone: true,
  imports: [CommonModule, OneWebComponentsAngularModule],
  templateUrl: './view-notes.component.html',
  styleUrls: ['./view-notes.component.scss']
})
export class ViewNotesComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Output() closeDialog = new EventEmitter<void>();

  public noteText: string = '';

  constructor() { }

  ngOnInit(): void {
    this.loadNotes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.loadNotes();
    }
  }

  private loadNotes(): void {
    this.noteText = this.data?.tableData?.notificationData?.NoteText || '';
  }

  public onClose(): void {
    this.closeDialog.emit();
  }
}
